import {doRedirectDelete} from "../../actions/thunks/schemaThunks";

const onEditDelete = (component, endpoint = null, redirectUrl = null) => {
  const deleteEndpoint = endpoint || this.props.endpoint;
  const url = redirectUrl || this.props.deleteRedirectUrl;
  component.props.dispatch(doRedirectDelete(this.props.accessToken, deleteEndpoint, url));
};

export default onEditDelete;